import { render, staticRenderFns } from "./pagination.vue?vue&type=template&id=900ed9b0&"
import script from "./pagination.vue?vue&type=script&lang=ts&"
export * from "./pagination.vue?vue&type=script&lang=ts&"
import style0 from "./pagination.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports